import {connect} from '../../app/connect';
import TemplateCategoryCreatePopup from './TemplateCategoryCreatePopup';
import {showNotificationAction, createTemplateCategoryAction} from '../../app/actions';
import {getTemplateCategoryTitlesForUniqueValidation} from '../../app/templates/template-selectors';

const mapStateToProps = state => ({
  templateCategoryTitles: getTemplateCategoryTitlesForUniqueValidation(state)
});

const mapDispatchToProps = {
  createTemplateCategoryAction,
  showNotificationAction
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TemplateCategoryCreatePopup);
